import { Box, Typography } from '@mui/material';
import React from 'react';

import { IVariantOptionRow } from '../../../types/marketplace';

interface IProps {
  rows: IVariantOptionRow[];
}

// Read-only summary: values a vendor has marked unavailable are struck through rather than
// hidden, so the recipient sees the full option set before the options step.
export const VariantOptionRows: React.FC<IProps> = ({ rows }) =>
  rows.length ? (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      {rows.map((row) => (
        <Box key={row.name} sx={{ display: 'flex', gap: 1 }}>
          <Typography variant="body2" color="text.secondary">
            {row.name}:
          </Typography>
          <Typography variant="body2" color="text.primary">
            {row.values.map((value, index) => (
              <React.Fragment key={value.label}>
                <Box
                  component="span"
                  sx={value.isOut ? { color: 'text.disabled', textDecoration: 'line-through' } : undefined}
                >
                  {value.label}
                </Box>
                {index < row.values.length - 1 && ', '}
              </React.Fragment>
            ))}
          </Typography>
        </Box>
      ))}
    </Box>
  ) : null;
